import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { ProductView } from '@/components/product-view';
import { TawkChat } from '@/components/tawk-chat';
import Header from '@/components/ui-v2/header';
import Navigation from '@/components/ui-v2/navigation';
import { useDocumentTitle } from '@/lib/hooks/useDocumentTitle';
import { cn } from '@/lib/utils';
import { datasourceImportReportState } from '@/states/datasource-import-report.state';
import { editingCellState } from '@/states/editing-cell.state';
import { fullscreenState } from '@/states/fullscreen.state';
import { useAtomValue, useSetAtom } from 'jotai';

export function DealPage() {
  useDocumentTitle();
  const fullscreen = useAtomValue(fullscreenState);
  const setFullscreen = useSetAtom(fullscreenState);
  const editingCell = useAtomValue(editingCellState);
  const { dealId = '' } = useParams<{ dealId: string }>();
  const datasourceImportReport = useAtomValue(datasourceImportReportState);
  const isImportReportOpen = datasourceImportReport?.dealId === dealId;
  const editingCellRef = useRef(editingCell);
  editingCellRef.current = editingCell;

  // Priorité Escape : 1) annuler édition cellule, 2) fermer modales (Radix), 3) quitter fullscreen.
  useEffect(() => {
    if (!fullscreen) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      if (editingCellRef.current !== null) return;
      setFullscreen(false);
    };

    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, [fullscreen, setFullscreen]);

  return (
    <>
      <div
        className={cn(
          'flex h-screen w-screen flex-col',
          !fullscreen && 'overflow-y-auto'
        )}
      >
        {!fullscreen && (
          <>
            <div
              className={cn(
                'sticky top-0 z-navigation shrink-0 bg-white',
                isImportReportOpen && 'pointer-events-none blur-sm'
              )}
            >
              <Navigation />
            </div>
            <div
              className={cn(
                isImportReportOpen && 'pointer-events-none blur-sm'
              )}
            >
              <Header />
              <hr className="mt-4 shrink-0 border-t border-gray-100" />
            </div>
          </>
        )}

        <div className={cn('min-h-0 flex-1 px-10 ')}>
          <ProductView />
        </div>
      </div>
      <TawkChat />
    </>
  );
}
